import React, { useState } from "react";
import { useOfferTemplates } from "../../contexts/OfferTemplatesContext";
import Modal from "react-modal";
import DeleteButton from "../../components/UI/AlertDialog";
import Notification from "../../components/UI/Notification";

Modal.setAppElement("#root"); // Accessibility

const OfferTemplatesPage = () => {
  const {
    offerTemplates,
    loading,
    error,
    updateOfferTemplate,
    createOfferTemplate,
    deleteOfferTemplate,
  } = useOfferTemplates();
  const [formData, setFormData] = useState({ name: "", content: "" });
  const [isModalOpen, setModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false) // new
  const [notification, setNotification] = useState(null);
  const [formErrors, setFormErrors] = useState({}); // Validation errors
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const validationErrors = {};
    const today = new Date();
    today.setHours(0, 0, 0, 0);

    const onlyTextRegex = /^[A-Za-z\s]+$/;

    if (!formData.name.trim()) {
    validationErrors.name = "Name is required.";
    } else if (!onlyTextRegex.test(formData.name.trim())) {
      validationErrors.name = "Name should contain only letters and spaces.";
    }

    if (!formData.content.trim()) {
      validationErrors.content = "Content is required.";
      } else if (!onlyTextRegex.test(formData.content.trim())) {
        validationErrors.content = "Content should contain only letters and spaces.";
    }

    return validationErrors;
  };

  const handleCreateOrUpdateTemplate = async (e) => {
    e.preventDefault();

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
    setFormErrors(validationErrors);
    return;
    }	

    try {
      if (isEditing) {
        await updateOfferTemplate(formData.id, formData); // Update existing template
        // setNotification("Offer template updated successfully");
        setNotification({
            message: "Offer template updated successfully",
            type: "success",
        });
      } else {
        await createOfferTemplate(formData); // Create new template
        // setNotification("Offer template created successfully");
        setNotification({
            message: "Offer template created successfully",
            type: "success",
        });
      } 
      setFormData({ id: null, name: "", content: "" }); // Reset form
      setModalOpen(false); // Close modal
      setIsEditing(false);
      setFormErrors("")
    } catch (err) {
      alert(err.message);
      // setNotification(err.message);
      setNotification({
          message: err.message,
          type: "error",
      });
    }
  };

  const openEditModal = (template) => {
    setFormData({ id: template.id, name: template.name, content: template.content });
    setIsEditing(true);
    setModalOpen(true);
  };

  const handleDeleteOfferLetter = async (id) => {
    try {
      await deleteOfferTemplate(id);
      // setNotification("Offer template deleted successfully");
      setNotification({
        message: "Offer template deleted successfully",
        type: "success",
      });
    } catch (error) {
      // setNotification("Failed to delete offer template");
      setNotification({
        message: "Failed to delete offer template",
        type: "error",
      });
    }
  };

  return (
    <div className="px-3 py-2 bg-white dark:bg-gray-900 font-poppins rounded-lg">
      
      {/* notification compo */}
      {notification && (
        <Notification message={notification.message} type={notification.type} onClose={() => setNotification(null)} />
      )}

      {/* Page Title and Add Button */}
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-6">
        <h1 className="text-2xl font-semibold text-gray-800 dark:text-white">Offer Templates</h1>
        <button
          // onClick={() => setModalOpen(true)}
          onClick={() => {
            setFormData({ id: null, name: "", content: "" }); // Reset form
            setIsEditing(false);
            setModalOpen(true);
          }}
          className="bg-blue-600 text-white px-4 py-2 rounded-md hover:bg-blue-700 w-full sm:w-auto"
        >
          Add Offer Template
        </button>
      </div>

      {/* Error or Loading */}
      {loading && <p className="text-gray-500">Loading templates...</p>}
      {error && <p className="text-red-500">{error}</p>}

      {/* Templates List */}
      {offerTemplates.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">

            {offerTemplates.map((template) => (
              <div
                key={template.id}
                className="p-4 bg-white dark:bg-black rounded-lg shadow hover:shadow-md transition"
              >
                <h2 className="md:text-xl text-md font-semibold mb-2 text-gray-800 dark:text-white">{template.name}</h2>
                <p className="text-gray-600 mb-4 dark:text-gray-500">{template.content}</p>
                <div className="flex justify-between">
                  <button
                    onClick={() => openEditModal(template)}
                    className="text-blue-600 hover:text-blue-700 text-sm hover:underline hover:underline-offset-4"
                  >
                    Edit
                  </button>

                  <DeleteButton style={`text-red-600 hover:text-red-700 text-sm hover:underline hover:underline-offset-4`} onDelete={() => handleDeleteOfferLetter(template.id)} />
                </div>
              </div>
            ))}
        </div>
      ) : (<p className="text-center mt-10 dark:text-white">No offer templates available.</p>)}


      {/* Create/Edit Template Modal */}
      {/* new code */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={() => setModalOpen(false)}
        overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-end md:items-center z-50 backdrop-blur-sm"
        className="bg-white font-poppins dark:bg-gray-900 rounded-t-lg md:rounded-lg shadow-xl p-6 w-full max-w-md mx-auto relative transition-transform duration-300 transform md:animate-none animate-slideUp"
      >
        <div className="flex justify-between items-center font-semibold mb-4 text-gray-800">
          <p className="text-xl dark:text-white">{isEditing ? "Edit Template" : "Create New Template"}</p>
          <button className="hover:rounded-md hover:bg-gray-100 dark:bg-gray-800 dark:text-gray-400 dark:hover:text-red-500 px-4 py-2 hover:text-red-500" onClick={() => setModalOpen(false)}>X</button>
        </div>
        <form onSubmit={handleCreateOrUpdateTemplate} className="space-y-4">
          <div>
            <label className="block text-sm dark:text-white font-medium text-gray-700">Name <span className="text-red-500 ml-1">*</span></label>
            <input
              type="text"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              className="w-full p-3 dark:bg-black dark:text-white dark:border-gray-700 dark:focus:outline-none border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              placeholder="Enter template name"
              required
            />
            {formErrors.name && <p className="text-red-500 text-sm mt-1">{formErrors.name}</p>}
          </div>
          <div>
            <label className="block text-sm dark:text-white font-medium text-gray-700">Content <span className="text-red-500 ml-1">*</span></label>
            <textarea
              name="content"
              value={formData.content}
              onChange={handleInputChange}
              className="w-full p-3 dark:bg-black dark:text-white dark:border-gray-700 dark:focus:outline-none border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
              rows="4"
              placeholder="Enter template content"
              required
            ></textarea>
            {formErrors.content && <p className="text-red-500 text-sm mt-1">{formErrors.content}</p>}
          </div>
          <div className="flex justify-between items-center">
            <button
              type="button"
              onClick={() => setModalOpen(false)}
              className="px-4 py-2 dark:bg-black dark:text-white dark:border-blue-600 bg-gray-300 text-gray-800 rounded hover:bg-gray-400 transition mr-2"
            >
              Cancel
            </button>
            <button
              type="submit"
              className="px-6 py-2 bg-blue-600 text-white font-semibold rounded hover:bg-blue-700 transition"
            >
              {isEditing ? "Update" : "Create"}
            </button>
          </div>
        </form>
      </Modal>

    </div>
  );
};

export default OfferTemplatesPage;
